import { NavController, NavParams, App, ModalController, ViewController, ToastController, Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input } from '@angular/core';

import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { CommonProvider } from '../../../../providers/common';
import { DropzoneComponent, DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';


@Component({
  selector: 'page-rh-drive',
  templateUrl: 'rh-drive.html',
})
export class RhDrivePage implements OnInit {

  categories:any = null;
  categoriesDisplayed:boolean[];
  currUserId:any = this.authProvider.user.user_id;
  userToken:any = null;

  dropZoneConfig: DropzoneConfigInterface = null;



  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    private iab: InAppBrowser,
    private commonProvider: CommonProvider,
    private storage: Storage,
    public toastCtrl: ToastController,
    private plt: Platform
  ) {

    this.plt.ready().then(() => {
      // We need to get the access_token in order to use the dropzone, but it will be 'null' if we don't way for the platform to be ready
      this.storage.get('access_token').then(token => {
        if (token) {

          this.userToken = token;
          this.dropZoneConfig = {
            url: `${this.commonProvider.apiUrl}api/v1/file/${this.authProvider.user.user_id}/upload`,
            maxFilesize: 50,
            acceptedFiles: '',
            paramName: 'uploadedFile',
            headers: {
              'Authorization' : `${this.userToken}`
            }
          };
        }
      })
    })

  }

  ngOnInit() {
    this.loadDatas();
  }

  loadDatas() {

    // Load user files
    this.employeeRhProvider.getUserFiles().subscribe((res) => {
        if(res.success){
            this.categories = res.data;
            this.categoriesDisplayed = new Array(this.categories.length).fill(false);
        }
    });
  }

  toggleDisplay(i: number) {
    this.categoriesDisplayed[i] = !this.categoriesDisplayed[i];
  }

  setCategory(file_id, e){
    this.employeeRhProvider.setFileCategory(file_id, e).subscribe((res) => {
      if(res.success){
        this.loadDatas();
      }
    })
  }


  downloadFile(id){
    const browser = this.iab.create(this.commonProvider.s3PublicUrl + id, '_system', 'location=yes')
  }

  dropzoneCustFunc(e){
  }

  onDropZoneComplete(){
    let toast = this.toastCtrl.create({ message: "Votre fichier a bien été envoyé", duration: 6000, position: 'top'});
    toast.present();
    this.loadDatas();
  }

    dismiss() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/drive/rh-drive.ts